import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { resetParams, useIsMyCalendlyScope } from 'components/meetings/filter_modal';
import { TRACKING_EVENT_NAMES, useTrack } from 'hooks/analytics_events';
import { useFilters } from 'hooks/meetings/filters';
import { BaseState } from './base_state';
import noResultsImage from './no_results.svg';
const clearFiltersButtonCss = "c138wg4c";
const ClearFiltersButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(clearFiltersButtonCss, props.className)}>
    {I18n.t('publisher.meetings.empty_state.no_results_cta')}
  </Button>);
export const EmptyFilteredList = ({
  apply,
  filterDefaults
}) => {
  const dispatch = useDispatch();
  const track = useTrack();
  const {
    getFilterParams
  } = useFilters();
  const filterParams = getFilterParams(filterDefaults);
  const isMyCalendlyScope = useIsMyCalendlyScope();
  const onClear = () => {
    track({
      name: TRACKING_EVENT_NAMES.CTA_CLICKED,
      properties: {
        cta_key: 'meetings_page',
        cta_text: 'clear_filters'
      }
    });
    dispatch({
      type: 'RESET_FILTER_MODAL'
    });
    dispatch(apply({
      ...resetParams(true, isMyCalendlyScope, filterParams.search_keyword),
      ...filterDefaults
    }));
  };
  return <BaseState imgSrc={noResultsImage} heading={I18n.t('publisher.meetings.empty_state.no_results')} description={I18n.t('publisher.meetings.empty_state.no_results_suggestion')} ctaButton={<ClearFiltersButton onClick={onClear} />} isEmptyFilteredList />;
};

require("./empty_filtered_list.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./empty_filtered_list.js");